import {Controller} from "stimulus"
import $ from 'jquery';
import {set_locale} from './localize_controller'

let social_icon_object = {
   'facebook': 'icon-social-facebook',
    'whatsapp': 'fab fa-whatsapp',
    'twitter':'<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-brand-x"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 4l11.733 16h4.267l-11.733 -16z" /><path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772" /></svg>',
    'youtube':'icon-social-youtube',
    'instagram':'icon-social-instagram',
    'official' : 'icon-globe',
    'telegram' : 'fa fa-paper-plane-o',
}

function tpl_social_button(type, url) {
    let html = ` <a href="${url}" target="_blank" class="footer-link">
          <span class="${social_icon_object[type]}"></span>
        </a>`
    if(social_icon_object[type].includes('<svg  xmlns="http://www.w3.org/2000/svg"')){
        html = ` <a href="${url}" target="_blank" class="footer-link">
         ${social_icon_object[type]}
        </a>`
    }
    return html;
}

export default class extends Controller {

    connect() {
        set_locale().then(
            locale => {
                $.ajax({
                    url: `/${locale.locale}/preferences/to/social.json`,
                    data: {format: 'json'},
                    type: 'GET',
                    success: function (data) {
                        let social_area = $('.social-links');
                        let html = '';
                        data.map( element => {
                            html+= tpl_social_button(element.key.text,element.value);
                        })
                        social_area.map(area => {
                            social_area[area].innerHTML = html;
                        })



                    }
                })
            }
        )

    }
}